var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.1,
    height: 24,
    viewBox: "0 0 65.1 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1 20.9L34.7 0h-6.8L17.2 24h7.4l6.7-16.2 2.8 6.8h-3.9l-2.1 5.1h8.1L38 24h4c1.3 0 2.3-1 2.3-2.2 0-.3-.1-.5-.2-.8v-.1zM22.4 4.6l2-4.5H0V6h7.6v18h7V6h5.7c.9 0 1.8-.6 2.1-1.4zm30.4 13.6V.2h-7V24h15.1c1 0 1.8-.6 2.2-1.3l2-4.4H52.8v-.1z",
    fill: "#80C342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalLogo);
export default __webpack_public_path__ + "static/media/tal-logo.3cd8a0540446a7342340e858b7684c1f.svg";
export { ForwardRef as ReactComponent };